import { init, extractCoordinates, extractState } from '../google'

function findStateIndex(state) {
  const stateSelect = document.querySelector('[data-state-select]')
  const stateOptions = Array.from(stateSelect.querySelectorAll('option'))

  return stateOptions.findIndex((option) => option.innerHTML === state)
}

// eslint-disable-next-line complexity
function fillInAddress(element, result) {
  const address = element.getAttribute('data-address')
  const city = document.querySelector(`[data-address="${address}"][data-address-field="address_city"]`) || {}
  const state = document.querySelector(`[data-address="${address}"][data-address-field="address_state"]`) || {}
  const zipCode = document.querySelector(`[data-address="${address}"][data-address-field="address_zip_code"]`) || {}
  const country = document.querySelector(`[data-address="${address}"][data-address-field="address_country"]`) || {}

  let postcode = ''

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5i5Mr
  for (const component of result.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
    case 'postal_code': {
      postcode = `${component.long_name}${postcode}`;
      break;
    }

    case 'locality': {
      city.value = component.long_name;
      break;
    }

    case 'administrative_area_level_1': {
      state.value = component.long_name;
      break;
    }

    case 'country': {
      country.value = component.long_name;
      break;
    }

    default: {
      break;
    }
    }
  }

  zipCode.value = postcode;
  city.focus();
}

const OnboardingGeocoder = {
  mounted() {
    const address = this.el.getAttribute('data-address')
    const element = this.el

    this.el.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.key === 'Enter') {
        event.preventDefault()
      }
    })

    // eslint-disable-next-line complexity
    init(element, { types: ['geocode'] }, (result) => {
      const coordinates = extractCoordinates(result)
      const state = extractState(result)
      const stateSelect = document.querySelector('[data-state-select]')

      fillInAddress(element, result)

      if (state && stateSelect && stateSelect.selectedIndex === 0) {
        const optionIndex = findStateIndex(state)

        if (optionIndex) {
          stateSelect.selectedIndex = optionIndex

          stateSelect.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }
    })
  },
}

export default OnboardingGeocoder
